import React from 'react';
import { Grid, Typography } from '@mui/material';

import DisplayAddedRemoved from './DisplayAddedRemoved';

const DisplayDifferences = ({
  modifiedObj,
  business_types,
  integration,
  ...props
}) => {
  const setKeys = {
    deadline: 'Tipo tarifa',
    rate: 'Tarifa',
    cancellation_policies: 'Políticas de cancelacion',
  };

  return (
    <Grid>
      {['deadline', 'rate', 'cancellation_policies'].map((key, i) => {
        return (
          modifiedObj[key] && (
            <Grid
              container
              style={{
                padding: '0',
                display: 'flex',
                flexDirection: 'column',
              }}
              key={`${key}-${i}`}
            >
              <Typography>{setKeys[key]}</Typography>
              <Grid
                item
                style={{
                  color: 'black',
                  fontSize: '16px',
                  textTransform: 'capitalize',
                }}
              >
                <DisplayAddedRemoved
                  modified={modifiedObj[key]}
                  keyValue={key}
                  {...props}
                  business_types={business_types}
                  integration={integration}
                />
              </Grid>
            </Grid>
          )
        );
      })}
    </Grid>
  );
};

export default DisplayDifferences;
